export default __webpack_public_path__ + "static/media/Roboto-Light.333da16a.ttf";